export default __webpack_public_path__ + "static/media/right-arrow.3a95d900.svg";